import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class DirectDebitService {
  simplifyIban(iban: string): string {
    return iban.replace(/\s/g, '');
  }

  formatIban(iban: string | null | undefined): string {
    const groups = this.getDigitGroups(iban);
    return groups.join(' ');
  }

  maskAndFormatIban(iban: string | null | undefined): string {
    const groups = this.getDigitGroups(iban);

    if (groups.length <= 2) {
      return groups.join(' ');
    }

    const lastGroup = groups[groups.length - 1];

    if (lastGroup.length === 4) {
      return `${groups[0]} **** ${lastGroup}`;
    }

    const secondLastGroup = '*'.repeat(lastGroup.length) + groups[groups.length - 2].substring(lastGroup.length);
    return `${groups[0]} **** ${secondLastGroup} ${lastGroup}`;
  }

  private getDigitGroups(iban: string | null | undefined): string[] {
    const normalizedIban = this.removeWhitespace(iban);
    return normalizedIban.match(/.{1,4}/g) || [normalizedIban];
  }

  private removeWhitespace(value: string | null | undefined): string {
    if (value) {
      return value.replace(/\s/g, '');
    } else {
      return '';
    }
  }
}
